module.exports = __webpack_public_path__ + "img/icon_map_6_on_001.d8751455.png";